import { asRange } from "./as-range";

export function trackListLong(races) {
  var tracks = races.reduce((byTrack, race) => {
    var numbers = byTrack[race.get("track_name")] || [];
    numbers.push(race.get("race_number"));
    byTrack[race.get("track_name")] = numbers;
    return byTrack;
  }, {});

  Object.keys(tracks).forEach((track) => {
    tracks[track] = asRange(tracks[track]);
  });

  return tracks;
}

export function trackListShort(races) {
  var tracks = races.reduce((byTrack, race) => {
    var numbers = byTrack[race.get("track_abbreviation")] || [];
    numbers.push(race.get("race_number"));
    byTrack[race.get("track_abbreviation")] = numbers;
    return byTrack;
  }, {});

  Object.keys(tracks).forEach((track) => {
    tracks[track] = asRange(tracks[track]);
  });

  return tracks;
}
